<template>
  <div class="container">
    <div>
      <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap my-4">
        <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap">
          <o-icon
            @click="$router.push({name: 'Domain', query: {'q': $route.query.q}})"
            icon="arrow-left" size="medium" clickable class="mr-4"></o-icon>
          <h1 v-if="domain" class="title">{{ domain.name }}</h1>
        </div>
        <div v-if="companyFields.length > 0 || personalFields.length > 0"
          class="is-flex is-justify-content-space-between is-flex-wrap-wrap">
          <o-button v-if="!isMyDomain"
                    class="mr-2"
                    variant="success"
                    @click="exportAllCustomFields">Export All
          </o-button>
<!--          <o-button v-if="isMyDomain"-->
<!--                    class="ml-2"-->
<!--                    variant="danger"-->
<!--                    @click="deleteAllCustomFields">Delete All-->
<!--          </o-button>-->
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <h2 class="subtitle">Company Field</h2>
        <div v-if="companyFields.length > 0">
          <div v-for="companyField in companyFields"
               class="custom-field my-3 p-3 is-size-5 is-flex is-justify-content-space-between">
            <div>
              {{ companyField.title }} [{{ companyField.type }} field]
            </div>
            <div>
              <o-icon v-if="isMyDomain" class="mx-1" clickable icon="pen"
                      @click="editCustomFieldModal(companyField, 'custom_fields_domain')"/>
              <o-icon v-if="isMyDomain" class="mx-1" clickable icon="trash" variant="danger"
                      @click="deleteCustomField(companyField, 'custom_fields_domain')"/>
            </div>
          </div>
        </div>
        <o-button v-if="isMyDomain"
                  class="is-success"
                  @click="addCustomFieldModal('custom_fields_domain')">Add Field</o-button>
      </div>
      <div class="column">
        <h2 class="subtitle">Personal Field</h2>
        <div v-if="personalFields.length > 0">
          <div v-for="personalField in personalFields"
               class="custom-field my-3 p-3 is-size-5 is-flex is-justify-content-space-between">
            <div>
              {{ personalField.title }} [{{ personalField.type }} field]
            </div>
            <div>
              <o-icon v-if="isMyDomain" class="mx-1" clickable icon="pen"
                      @click="editCustomFieldModal(personalField, 'custom_fields_user')"/>
              <o-icon v-if="isMyDomain" class="mx-1" clickable icon="trash" variant="danger"
                      @click="deleteCustomField(personalField, 'custom_fields_user')"/>
            </div>
          </div>
        </div>
        <o-button v-if="isMyDomain"
                  class="is-success"
                  @click="addCustomFieldModal('custom_fields_user')">Add Field</o-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CustomFieldsModal from "../components/modals/CustomFieldsModal";
import {mapGetters} from "vuex";
import Confirm from "../components/modals/Confirm";


export default {
  name: "CustomFields",
  components: [CustomFieldsModal],
  data() {
    return {
      domain: null,
      companyFields: [],
      personalFields: []
    }
  },
  methods: {
    addCustomFieldModal(customFieldType) {
      this.$oruga.modal.open({
        parent: this,
        component: CustomFieldsModal,
        custom: true,
        trapFocus: true,
        props: {
          title: 'Add New Custom Field'
        },
        events: {
          'onComplete': (data) => {
            this.saveCustomField({
              'domain_id': this.domain.id,
              [customFieldType]: data,
            })
          }
        }
      })
    },
    editCustomFieldModal(customField, customFieldType) {
      this.$oruga.modal.open({
        parent: this,
        component: CustomFieldsModal,
        custom: true,
        trapFocus: true,
        props: {
          title: 'Edit Custom Field',
          initialData: customField
        },
        events: {
          'onComplete': (data) => {
            this.editCustomField({
              'domain_id': this.domain.id,
              [customFieldType]: data,
            })
          }
        }
      })
    },
    saveCustomField(data) {
      axios.post('/api/domain/custom-fields/', data)
        .then(response => {
          this.getDomainFields()
          this.$oruga.notification.open({
            message: 'Saved',
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    editCustomField(data) {
      axios.put('/api/domain/custom-fields/', data)
        .then(response => {
          this.getDomainFields()
          this.$oruga.notification.open({
            message: 'Updated',
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    exportAllCustomFields() {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Exporting custom fields`,
          'message': `Export all custom fields to ${this.getAdmin.domain}`,
          'confirmText': "Export",
          'variant': 'success'
        },
        events: {
          'onConfirm': () => {
            axios.post('/api/domain/custom-fields/export_all', {
              'from_domain_id': this.domain.id,
            })
              .then(() => {
                this.$oruga.notification.open({
                  message: 'Exported',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    deleteCustomField(customField, customFieldType) {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting ${customField.title}`,
          'message': `Are you sure you want to delete <b>${customField.title}</b> [${customField.type} field]?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.post('/api/domain/custom-fields/delete', {
              'domain_id': this.domain.id,
              [customFieldType]: customField,
            })
              .then(() => {
                this.$oruga.notification.open({
                  message: 'Deleted',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomainFields()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    deleteAllCustomFields() {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting ALL custom fields`,
          'message': `Are you sure you want to delete <b>ALL</b> custom fields?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.post('/api/domain/custom-fields/delete_all', {'domain_id': this.domain.id})
              .then(() => {
                this.$oruga.notification.open({
                  message: 'Deleted',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomainFields()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    getDomainFields() {
      axios.get('/api/domain/custom-fields/', {params: {'q': this.$route.query.q}})
        .then(response => {
          this.domain = response.data['domain']
          this.companyFields = response.data['company_fields']
          this.personalFields = response.data['personal_fields']
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
  },
  computed: {
    ...mapGetters('auth', ['getAdmin']),
    isMyDomain() {
      if (this.domain)
        return this.domain.id === this.getAdmin.domain_id
      return false
    }
  },
  created() {
    this.getDomainFields()
  }
};
</script>

<style>
.custom-field {
  color: #00947e;
  background: #ebfffc;
  border-color: #00d1b2;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
}
</style>
